import { apiUrl, fetchJson } from '../../apiBase';

// Aggregate homework status across all students for a date range.
// Expected response shape:
// { items: [ { id, name, surname, class_name, done_count, missing_count, late_count, total_count } ] }
// Endpoint assumption; adjust if backend differs.
export async function listHomeworkAggregateRange(school, start, end, classId) {
  const params = new URLSearchParams();
  params.set('start', start);
  params.set('end', end);
  if (classId) params.set('class_id', classId);
  const url = apiUrl(`/admin/homeworks/${encodeURIComponent(school)}/aggregate?${params.toString()}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
